import React, { PropTypes } from 'react';
import Reflux from 'reflux';
import { VariableSizeList as List } from 'react-window';
import _ from 'underscore';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import classnames from 'classnames';
import FeaturedFullScreenHotKeyHandlers from 'main/components/show/cuesheet.prompter/featuredFullScreenHotKeyHandlers';
import FullScreenCuesheetStore from 'flux/stores/cuesheet.fullscreen/FullScreenCuesheetStore';
import FullScreenCuesheetActions from 'flux/actions/cuesheet.fullscreen/FullScreenCuesheetActions';
import RemoteTeleprompterActions from 'flux/actions/cuesheet.fullscreen/RemoteTeleprompterActions';
import RemoteTeleprompterStore from 'flux/stores/cuesheet.fullscreen/RemoteTeleprompterStore';
import {
  isRemoteTeleprompter,
  isTeleprompter,
} from 'main/components/show/cuesheet/cuesheetViewHelper';
import RowRenderer from 'main/components/show/cuesheet.prompter/rowRenderer';
import RowHeightHelper from 'main/components/show/cuesheet.prompter/rowHeightHelper';

import {
  ReactWindowAutoScrollSpeeds,
  FixedEditorWidth,
  PrompterWidths,
  ReadArrowMirroredStyles,
  ReadArrowDefaultStyles,
  ReadArrowTopStyleDefault,
} from 'shared/constants/FeaturedEditorConstants';
import { isPC } from 'shared/lib/platformCheck';

const scrollDeltaDivisor = 12;
const intervalTime = 1000 / 60;
const emitScrollThrottleTime = 200;
const intervalsPerEmit = emitScrollThrottleTime / intervalTime;
let rowHeightCache = {};
let operatorScrollTop = 0;
let scrollBarWidth = 0;

export default React.createClass({
  displayName: 'PrompterList',
  propTypes: {
    height: PropTypes.number,
    width: PropTypes.number,
    loading: PropTypes.bool,

    zoom: PropTypes.number,
    lineHeight: PropTypes.number,
    fontWeight: PropTypes.string,
    prompterItemInfoEnabled: PropTypes.bool,

    itemSetId: PropTypes.string,

    //Initial row Id for prompert view that is set in the url
    rowId: PropTypes.string,
    //Initial column Id for prompert view that is set in the url
    columnId: PropTypes.string,

    rowOrder: PropTypes.array,
    rowMap: PropTypes.object,
    selectedCells: PropTypes.array,
    editingCell: PropTypes.object,

    autoScrollEnabled: PropTypes.bool,
    autoScrollSpeedIndex: PropTypes.number,

    defaultRTEText: PropTypes.string,
    featuredCapitalization: PropTypes.bool,
    prompterTextMirror: PropTypes.bool,
    prompterTextVerticalMirror: PropTypes.bool,

    //Actions
    onBlur: PropTypes.func,
    onSelect: PropTypes.func,
    onStartEdit: PropTypes.func,
    onStopEdit: PropTypes.func,
    onCancelEdit: PropTypes.func,
  },

  mixins: [
    Reflux.ListenerMixin,
    Reflux.connect(RemoteTeleprompterStore, 'remoteTeleprompter'),
    Reflux.connect(FullScreenCuesheetStore, 'fullScreenCuesheet'),
  ],

  ...FeaturedFullScreenHotKeyHandlers,

  getInitialState() {
    return {
      keysBound: false,
      isScrolling: false,
      readArrowTop: ReadArrowTopStyleDefault,
    };
  },

  componentWillMount() {
    this.activeRowBuffer = [];
    this._scrollTop = 0;
    this._toggleAutoScroll = _toggleAutoScroll.bind(this);
    this._scrollInterval = _scrollInterval.bind(this);
    this._handleScroll = _handleScroll.bind(this);
    // we calculate the scrollbar width once the component mounts to be precise, but
    // this is the default scrollbar width on pcs
    if (isPC()) scrollBarWidth = 17;

    if (isRemoteTeleprompter()) {
      this.listenTo(
        RemoteTeleprompterActions.updateOperatorScrollTop,
        (scrollTop) => {
          operatorScrollTop = scrollTop;
          this._smoothRemoteScroll();
        },
      );
    }

    this.listenTo(
      FullScreenCuesheetActions.scrollToRowIdInPrompter,
      (rowId) => {
        const rowIndex = this.props.rowOrder.indexOf(rowId);
        this._list.scrollToItem(rowIndex, 'start');
      },
    );

    /**
     * Enable hot key bindings inside of FeaturedFullScreenHotKeyHandlers...
     * above.
     */
    if (isTeleprompter()) {
      this._enableFullScreenHotKeys();
      this._enableToggleFullScreenHotKeys();
    }
  },

  componentDidMount() {
    const { rowId, rowOrder, remote } = this.props;

    if (this._list && rowOrder && rowId) {
      const { offsetWidth, clientWidth } = this._outerListRef;

      scrollBarWidth = offsetWidth - clientWidth;

      const rowIndex = rowOrder.indexOf(rowId);

      for (let i = rowIndex; i < rowOrder.length; i++) {
        this._rowHeightGetter(i);
      }
      this._list.scrollToItem(rowIndex, 'start');
      this._updateActiveRow(rowIndex);
    }
    if (!remote) {
      this._emitOperatorSettings();
    }
  },

  componentWillReceiveProps(nextProps) {
    const { autoScrollEnabled, autoScrollSpeedIndex } = this.props;

    if (
      autoScrollEnabled !== nextProps.autoScrollEnabled ||
      autoScrollSpeedIndex !== nextProps.autoScrollSpeedIndex
    ) {
      this._toggleAutoScroll(nextProps);
    }
  },

  componentDidUpdate(prevProps) {
    const { changedRows, remote } = this.props;

    const { remoteTeleprompter } = this.state;
    const { cache } = remoteTeleprompter;
    const {
      columnId,
      rowId,
      eventId,
      autoScrollEnabled,
      autoScrollSpeedIndex,
      prompterReadArrowEnabled,
      //
      prompterItemInfoEnabled,
      prompterTextMirror,
      prompterTextVerticalMirror,
      prompterSingleItemEnabled,
      prompterWidthIndex,
      zoom,
      lineHeight,
      fontWeight,
      rowMap,
      rowOrder,
      featuredCapitalization,
      width,
      height,
    } = prevProps;

    let shouldForceUpdate = false;
    let usePromisedRow = false;
    let emitSettings = false;
    let recomputeIndex;

    if (remote && cache) {
      const differingIndex = findRowHeightDiffIndex(cache);
      if (differingIndex !== -1) {
        rowHeightCache = cache;
        shouldForceUpdate = true;
        recomputeIndex = 0;
      }
    }

    // settings that dont affect row height but do affect the underlying Grid
    if (
      prompterTextMirror !== this.props.prompterTextMirror ||
      prompterTextVerticalMirror !== this.props.prompterTextVerticalMirror ||
      height !== this.props.height
    ) {
      shouldForceUpdate = true;
      recomputeIndex = 0;
    }

    if (rowOrder !== this.props.rowOrder) {
      shouldForceUpdate = true;
      recomputeIndex = 0;
    }

    // settings that affect row height and the underlying List
    if (
      lineHeight !== this.props.lineHeight ||
      fontWeight !== this.props.fontWeight ||
      prompterItemInfoEnabled !== this.props.prompterItemInfoEnabled ||
      prompterWidthIndex !== this.props.prompterWidthIndex ||
      featuredCapitalization !== this.props.featuredCapitalization ||
      prompterSingleItemEnabled !== this.props.prompterSingleItemEnabled ||
      width !== this.props.width ||
      zoom !== this.props.zoom
    ) {
      shouldForceUpdate = true;
      usePromisedRow = true;
      emitSettings = true;
      recomputeIndex = 0;
    }

    if (recomputeIndex !== 0 && rowMap !== this.props.rowMap) {
      shouldForceUpdate = true;
      if (changedRows) {
        const changedRowIndexes = Object.keys(changedRows);
        changedRowIndexes.forEach((ind) => {
          delete rowHeightCache[ind];
        });
        FullScreenCuesheetActions.clearChangedRows();
        recomputeIndex = Math.min(changedRowIndexes);
      } else {
        rowHeightCache = {};
        usePromisedRow = true;
        recomputeIndex = 0;
      }
    }

    if (!remote) {
      if (
        columnId !== this.props.columnId ||
        rowId !== this.props.rowId ||
        eventId !== this.props.eventId ||
        autoScrollEnabled !== this.props.autoScrollEnabled ||
        autoScrollSpeedIndex !== this.props.autoScrollSpeedIndex ||
        prompterReadArrowEnabled !== this.props.prompterReadArrowEnabled
      ) {
        emitSettings = true;
      }
      if (emitSettings) {
        this._emitOperatorSettings();
      }
    }

    if (shouldForceUpdate) {
      const promisedRow = this._activeRowIndex;
      if (!remote) {
        for (let i = recomputeIndex; i < this.props.rowOrder.length; i++) {
          delete rowHeightCache[i];
        }
      }
      if (typeof recomputeIndex === 'number') {
        this._list.resetAfterIndex(recomputeIndex);
      }
      // todo: review promised row logic
      if (recomputeIndex === 0 && usePromisedRow && promisedRow) {
        this.setState({ promisedRow }, () => {
          this._list.scrollToItem(this.state.promisedRow, 'start');
        });
      }
    }
  },

  _emitOperatorSettings() {
    const settings = _.pick(
      this.props,
      'columnId',
      'rowId',
      'eventId',
      // Passed settings
      'zoom',
      'zoomIndex',
      'lineHeight',
      'lineHeightIndex',
      'autoScrollEnabled',
      'autoScrollSpeedIndex',
      'featuredCapitalization',
      'fontWeight',
      'prompterItemInfoEnabled',
      'prompterSingleItemEnabled',
      'prompterRealTimeEditsEnabled',
      'prompterReadArrowEnabled',
      'prompterTextMirror',
      'prompterTextVerticalMirror',
      'width',
    );
    settings.cache = rowHeightCache;
    throttledEmitOperatorSettings(settings);
  },

  componentWillUnmount() {
    /**
     * Disable hot key bindings inside of FeaturedFullScreenHotKeyHandlers...
     * above.
     */
    this._disableFullScreenHotKeys();
    this._disableToggleFullScreenHotKeys();
  },

  render() {
    const {
      editingCell,
      height,
      prompterWidthIndex,
      remote,
      rowOrder,
      scale,
      scaleStyles,
      width,
    } = this.props;

    if (!rowOrder || rowOrder.length < 1) return null;

    const listClasses = classnames('teleprompter-overflow', {
      editing: editingCell.rowId,
      'disable-teleprompter-user-scroll': remote,
    });
    const listHeight = scale < 1 ? height / scale : height;
    let listWidth =
      FixedEditorWidth * PrompterWidths[prompterWidthIndex] + scrollBarWidth;
    const style = { left: (width - listWidth) / 2 };

    return (
      <div style={scaleStyles} onClick={this.props.onClick}>
        {this._getReadArrowNode()}
        <List
          id="editorList"
          style={style}
          className={listClasses}
          height={listHeight}
          width={listWidth}
          ref={this._setListRef}
          outerRef={this._setOuterListRef}
          itemCount={rowOrder.length}
          estimatedItemSize={listHeight}
          itemSize={this._rowHeightGetter}
          overscanCount={1}
          onScroll={this._handleScroll}
        >
          {this._rowRenderer}
        </List>
      </div>
    );
  },

  _onArrowDrag(e) {
    e.stopPropagation();
    e.preventDefault();
  },

  _onArrowStartDrag(e) {
    this.setState({ startDrag: e.clientY });
  },

  _onArrowStopDrag(e) {
    const stopDrag = e.clientY;
    const { readArrowTop, startDrag } = this.state;
    const { scale } = this.props;
    const arrowBounds = e.target.getBoundingClientRect();
    let { height } = arrowBounds;
    let diff = stopDrag - startDrag;
    let scaledDiff = diff / this.props.scale;
    const midPointScaledArrow = height / 2;
    const midPointOriginalArrow = height / scale / 2;

    let scaledMidPointDiff =
      (midPointOriginalArrow - midPointScaledArrow) / scale;

    let newReadArrowTop = readArrowTop + scaledDiff + scaledMidPointDiff;

    this.setState({ readArrowTop: newReadArrowTop });
    throttledEmitOperatorSettings({
      readArrowTop: newReadArrowTop,
    });
  },

  _getReadArrowNode() {
    const { remote, prompterWidthIndex, width } = this.props;
    const { remoteTeleprompter, fullScreenCuesheet } = this.state;
    const { userSettings } = fullScreenCuesheet;

    let { readArrowTop } = this.state;

    let { prompterTextMirror, prompterReadArrowEnabled } = userSettings;

    if (remote) {
      readArrowTop = remoteTeleprompter.readArrowTop;
      prompterReadArrowEnabled = remoteTeleprompter.prompterReadArrowEnabled;
      prompterTextMirror = remoteTeleprompter.prompterTextMirror;
    }

    if (!prompterReadArrowEnabled) return null;

    const innerEditorwidth =
      FixedEditorWidth * PrompterWidths[prompterWidthIndex];

    let readArrowOffset = (width - innerEditorwidth) / 2 - 70;

    const readArrowStyles = prompterTextMirror
      ? ReadArrowMirroredStyles
      : ReadArrowDefaultStyles;

    if (prompterTextMirror) {
      readArrowStyles.right = `${readArrowOffset}px`;
    } else {
      readArrowStyles.left = `${readArrowOffset}px`;
    }

    return (
      <div
        className="featured-fullscreen-editor-reading-arrow-wrapper"
        style={readArrowStyles}
        onDrop={this._onArrowDrop}
        onDragOver={this._onArrowDrag}
        onDragStart={this._onArrowStartDrag}
        onDragEnd={this._onArrowStopDrag}
      >
        <div style={{ marginTop: readArrowTop }} />
        <span
          id="draggableArrow"
          onClick={this._onClosePanelsClick}
          className="featured-fullscreen-editor-reading-arrow-draggable"
          draggable={!remote}
        >
          <Icon
            style={prompterTextMirror ? { transform: 'rotate(180deg)' } : {}}
            className="featured-fullscreen-editor-reading-arrow"
            name="caret-right"
          />
        </span>
      </div>
    );
  },

  _setOuterListRef(ref) {
    if (ref) {
      this._outerListRef = ref;
      this._outerListRef.id = 'prompter-list-wrapper';
    }
  },

  _setListRef(ref) {
    this._list = ref;
  },

  _rowHeightGetter(index) {
    const { rowOrder, prompterWidthIndex } = this.props;
    const listWidth = FixedEditorWidth * PrompterWidths[prompterWidthIndex];

    if (rowHeightCache[index]) {
      return rowHeightCache[index];
    }

    const rowId = rowOrder[index];
    const item = this._getRowItem(rowId);

    const rowProps = {
      ...this.props,
      scrollTop: this._scrollTop,
      rowId,
      isEditing: false,
      isSelected: false,
      rowOffset: 0,
      editorState: this._getEditorState(item),
      item,
    };

    const row = RowRenderer({ index, style: {} }, rowProps);

    const rowHeight = RowHeightHelper.getRowHeight(row, listWidth, index);
    rowHeightCache[index] = rowHeight;
    throttledEmitCache();
    return rowHeight;
  },

  _rowRenderer(renderProps) {
    const { index } = renderProps;
    const { columnId, prompterWidthIndex, rowOrder } = this.props;
    const listWidth = FixedEditorWidth * PrompterWidths[prompterWidthIndex];

    const rowId = rowOrder[index];
    const item = this._getRowItem(rowId);

    const rowProps = {
      ...this.props,
      listWidth,
      scrollTop: this._scrollTop,
      rowId,
      isEditing: this._isCellInEditMode(rowId, columnId),
      isSelected: this._isCellSelected(rowId, columnId),
      editorState: this._getEditorState(item),
      item,
    };

    return RowRenderer(renderProps, rowProps);
  },

  _isCellSelected(rowId, columnId) {
    const { selectedCells } = this.props;
    if (!selectedCells) return false;
    return selectedCells[`${rowId}_${columnId}`];
  },

  _isCellInEditMode(rowId, columnId) {
    const { editingCell } = this.props;
    if (!editingCell) return false;
    return editingCell.rowId === rowId && editingCell.columnId === columnId;
  },

  _getRowItem(rowId) {
    const { rowMap, itemSetId } = this.props;

    if (!rowId || !rowMap || !itemSetId) return null;

    return rowMap[itemSetId].rows[rowId]
      ? rowMap[itemSetId].rows[rowId].item
      : null;
  },

  _getEditorState(item) {
    if (!item) return null;

    const { columnId } = this.props;

    const editorState = item.cells[columnId]
      ? item.cells[columnId].editorState
      : null;

    return editorState;
  },

  _scrollToRowId(rowId) {
    const rowIndex = this.props.rowOrder.indexOf(rowId);
    this._list.scrollToItem(rowIndex, 'start');
  },

  _updateActiveRow(index) {
    const { rowOrder } = this.props;
    const rowId = rowOrder[index];
    FullScreenCuesheetActions.updateActiveRowInRowPanel(rowId);
    this._activeRowIndex = index;
    throttledEmitOperatorSettings({ rowId });
  },

  _smoothRemoteScroll() {
    if (this.props.autoScrollEnabled) {
      if (this.smoothScrollInterval) {
        clearInterval(this.smoothScrollInterval);
        delete this.smoothScrollInterval;
      }
      return;
    }

    if (this.smoothScrollInterval) {
      return;
    }
    this.smoothScrollInterval = setInterval(this._smoothScroll, intervalTime);
  },

  _smoothScroll() {
    if (operatorScrollTop === this._scrollTop && this.smoothScrollInterval) {
      clearInterval(this.smoothScrollInterval);
      delete this.smoothScrollInterval;
      return;
    }
    const scrollDelta = Math.abs(operatorScrollTop - this._scrollTop);
    let intervalAmount = Math.round(scrollDelta / scrollDeltaDivisor) || 1;

    if (scrollDelta < intervalAmount) intervalAmount = scrollDelta;

    if (this._scrollTop > operatorScrollTop) {
      intervalAmount = -intervalAmount;
    }
    const newScrollTop = (this._scrollTop += intervalAmount);
    this._outerListRef.scrollTo({
      top: newScrollTop,
      left: 0,
      behavior: 'auto',
    });
  },
});

export function _toggleAutoScroll(props) {
  const { autoScrollEnabled, autoScrollSpeedIndex } = props;

  let scrollObject = ReactWindowAutoScrollSpeeds[autoScrollSpeedIndex];
  const { direction } = scrollObject;

  if (this.autoScrollInterval) {
    clearInterval(this.autoScrollInterval);
    delete this.autoScrollInterval;
  }

  if (!autoScrollEnabled || !direction || !this._list) {
    throttledEmitOperatorScrollPosition(this._scrollTop);
    return;
  }

  this.autoScrollInterval = setInterval(this._scrollInterval, intervalTime);
}

let roundUp = true;
export function _scrollInterval() {
  const { autoScrollSpeedIndex, remote } = this.props;

  if (!this._list) return;

  let scrollObject = ReactWindowAutoScrollSpeeds[autoScrollSpeedIndex];

  let { direction, intervalAmount } = scrollObject;

  const roundFunction = roundUp ? Math.round : Math.floor;

  let newScrollTop;
  if (direction === 'down') {
    if (remote) {
      intervalAmount = _getDeltaHedgeIntervalAmount(
        this._scrollTop,
        intervalAmount,
        direction,
      );
    }
    if (intervalAmount === 0) {
      return;
    }
    intervalAmount = roundFunction(intervalAmount);
    newScrollTop = this._scrollTop + intervalAmount;
  }

  if (direction === 'up') {
    if (remote) {
      intervalAmount = _getDeltaHedgeIntervalAmount(
        this._scrollTop,
        intervalAmount,
        direction,
      );
    }
    if (intervalAmount === 0) {
      return;
    }
    intervalAmount = roundFunction(intervalAmount);
    newScrollTop = Math.max(this._scrollTop - intervalAmount, 0);
  }

  if (
    (this._scrollTop === 0 && newScrollTop === 0) ||
    newScrollTop === undefined
  )
    return;

  this._outerListRef.scrollTo({
    top: newScrollTop,
    left: 0,
    behavior: 'auto',
  });

  roundUp = !roundUp;
}

function _getDeltaHedgeIntervalAmount(scrollTop, intervalAmount, direction) {
  let scrollDelta = Math.abs(operatorScrollTop - scrollTop);
  let range = intervalsPerEmit * intervalAmount;
  if (scrollDelta < range) {
    return intervalAmount;
  }

  if (direction === 'down' && scrollTop > operatorScrollTop) {
    scrollDelta = scrollDelta * -1;
    if (Math.abs(scrollDelta) / intervalsPerEmit < intervalAmount + 1) {
      return intervalAmount / 2;
    }
  }

  if (direction === 'up' && scrollTop < operatorScrollTop) {
    scrollDelta = scrollDelta * -1;
    if (Math.abs(scrollDelta) / intervalsPerEmit < intervalAmount + 1) {
      return intervalAmount / 2;
    }
  }

  return scrollDelta / (intervalsPerEmit / 2);
}

function _setActiveRowOnScroll() {
  if (this._list) {
    const { rowOrder } = this.props;
    let newActiveRow;
    let rowStartOffset = 0;
    for (let i = 0; i < rowOrder.length; i++) {
      const rowHeight = rowHeightCache[i];
      const rowEndOffset = rowStartOffset + rowHeight;
      if (this._scrollTop >= rowStartOffset && this._scrollTop < rowEndOffset) {
        newActiveRow = i;
        break;
      }
      rowStartOffset += rowHeight;
    }
    if (this._activeRowIndex !== newActiveRow) {
      this._updateActiveRow(newActiveRow);
    }
  }
}

const throttledSetActiveRowOnScroll = _.throttle(_setActiveRowOnScroll, 500);
const throttledEmitOperatorSettings = _.throttle(
  RemoteTeleprompterActions.emitOperatorSettings,
  500,
);

const throttledEmitCache = _.debounce(() => {
  RemoteTeleprompterActions.emitCache(rowHeightCache);
}, 500);

const throttledEmitOperatorScrollPosition = _.throttle(
  (scrollTop) => RemoteTeleprompterActions.emitScrollPosition(scrollTop),
  emitScrollThrottleTime,
);

export function _handleScroll({ scrollOffset }) {
  const { remote } = this.props;
  this._scrollTop = scrollOffset;
  throttledSetActiveRowOnScroll.call(this);
  if (!remote) {
    throttledEmitOperatorScrollPosition(this._scrollTop);
  }
}

function findRowHeightDiffIndex(operatorCache) {
  if (!operatorCache) return -1;

  let result = Object.keys(operatorCache).findIndex((key) => {
    return operatorCache[key] !== rowHeightCache[key];
  });
  return result;
}
